"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureAction = void 0;
exports.FeatureAction = {
    create: (featureKey, actionKey, definition) => {
        return {
            NAME: definition.name,
            DESCRIPTION: definition.description,
            featureKey,
            actionKey,
        };
    },
};
